import { AF, AUTHTOKEN, ISACTIVE, USER } from "@/constants";
import { HTTP } from "@/http-common";
import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: null,
    isActive: false,
    isDone: false,
    landingPageLanguage: window.localStorage.getItem("landingpage") ?? "ar", 

  }),
  getters: {
    isAuthenticated: (state) => !!state.user,
    getIsActive: (state) => state.isActive,
    getIsDone: (state) => state.isDone,
    getLandingPageLanguage: (state) => state.landingPageLanguage,
  },
  actions: {
    /**
     * Call antifraud API
     * @params package name
     * @returns {Promise} API response
     */
    async callAntifraudAPI(packageName) {
      return new Promise((resolve, reject) => {
        HTTP.get(`api/auth/ksa/stc/antifraud?subscriptionPackage=${packageName}`)
          .then((response) => {
            console.log("Antifraud API response:", response);
            resolve(response);
          })
          .catch((error) => {
            console.error("Error calling antifraud API:", error);
            reject(error);
          });
      });
    },

    /**
     * Call OTP API
     * @param {*} msisdn
     * @param {*} subscriptionPackage
     * @returns {Promise} API response
     */

    async callOtpAPI(msisdn,  subscriptionPackage, referenceUserId = null) {
      const antiFraudUniqid = localStorage.getItem(AF);

      const payload = {
        msisdn,
        antiFraudUniqid,
        subscriptionPackage,
      };

      if (referenceUserId) {
        payload.referenceUserId = referenceUserId;
      }


      return new Promise((resolve, reject) => {
        HTTP.post("api/auth/ksa/stc/otp", payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            console.error("Error calling OTP API:", error);
            console.error("Error details:", error.response?.data || error.message);
            reject(error);
          });
      });
    },
    /**
     * 
     * @param {*} queryParams 
     * @returns 
     */

    async callStatusAPI(queryParams) {
      return new Promise((resolve, reject) => {
        HTTP.post("/api/auth/ksa/stc/status", queryParams)
          .then((response) => {
            if (response.data.status === "Success") {
              this.setUserData(response);
            } else {
              this.wipeUserData();
            }
            resolve(response);
          })
          .catch((error) => {
            console.error("Error calling Status API:", error);
            reject(error);
          });
      });
    },

    /**
     * Check subscription status for STC KSA
     * @param {string} msisdn - Phone number
     * @returns {Promise} API response
     */
    async checkSubescriptionStatus(msisdn) {
      const payload = {
        msisdn: msisdn,
        issue_token: true
      };

      return new Promise((resolve, reject) => {
        HTTP.post("api/auth/login_by_msisdn", payload)
          .then((response) => {
            console.log("Subscription status response:", response);
            if (response.data.success || response.data.isActive) {
              this.setUserData(response);
            }
            resolve(response);
          })
          .catch((error) => {
            console.error("Error checking subscription status:", error);
            reject(error);
          });
      });
    },

    /**
     * Unsubscribe from STC service
     * @returns {Promise} API response
     */

    async unSubscribeStc() {
      const msisdn = JSON.parse(localStorage.getItem(USER))?.phone;
    
      const packageName = localStorage.getItem("selectedPrice");
      if (!msisdn || !packageName) {
        const response = {
          data: {
            success: false,
            error: true,
            message: "Missing required parameters"
          }

        };
        return response;
      }

      const payload = {
        msisdn: msisdn,
        subscriptionPackage: packageName
      };

      return new Promise((resolve, reject) => {
        HTTP.post("api/auth/ksa/stc/unsub", payload)
          .then((response) => {
            console.log("Unsubscribe response:", response);
            resolve(response);
          })
          .catch((error) => {
            console.error("Error calling unsubscribe API:", error);
            reject(error);
          });
      });
    },
    /**
     * Set user data to local storage [isActive,user,token]
     */
    async setUserData(response) {
      this.user = response.data.user;
      this.isActive = true;
      localStorage.setItem(USER, JSON.stringify(response.data.user));
      localStorage.setItem(ISACTIVE, response.data.token ? true : false);
      localStorage.setItem(AUTHTOKEN, response.data.token);

    },

    /**
     * wipe user data from local storage
     */
    wipeUserData() {
      this.user = null;
      this.isActive = false;
      localStorage.removeItem(USER);
      localStorage.removeItem(ISACTIVE);
      localStorage.removeItem(AUTHTOKEN);
    },

     async changeLanguage() {
      if (this.landingPageLanguage == "en") {
        this.landingPageLanguage = "ar";
        window.localStorage.setItem("landingpage", this.landingPageLanguage);
      } else if (this.landingPageLanguage == "ar") {
        this.landingPageLanguage = "en";
        window.localStorage.setItem("landingpage", this.landingPageLanguage);
      } else {
        this.landingPageLanguage = "en";
        window.localStorage.setItem("landingpage", this.landingPageLanguage);
      }

      return this.landingPageLanguage;
    },
  

  },
});
